<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <todo-new-employee>
        </todo-new-employee> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import TodoNewEmployee from './todo-new-employee'
export default {
  components: {
    TodoNewEmployee
  }
}
</script>
<style>
  .m-right{
  margin:0px !important;
  padding-right: 0px!important;
  }
  .bg-breadcrum{
  background:#fff;
  }
  .border-box-new-employee{
      border: 1px dashed #666!important;
      width: 100%!important;
      padding: 20px!important;
  }
  .font-awesome-size{
      font-size: 30px;
  }
  .action-item-exp-employee{
      margin-top:-415px;
      position: absolute;
      float:right;
  }
  .floater-point-exp{
      float: right;
      width: 100px;
      margin-right: -30px;
  }
  
  
  .action-item-dept{
      margin-top: -125px;
      position: absolute;
      float:right;
  }
  .floater-point-dept{
      float: right;
      width: 100px;
      margin-right: -30px;
  }
  
  .action-item-senior{
      position: absolute;
  }
  .floater-point-sinior{
      float: right;
      width: 100px;
      margin-right: -30px;
      margin-top: -126px;
  } 
  
  .title-section{
      font-size: 18px;
  }
  
  .invalid-feedback{
      color:red;
  }
  .p-text{
      color:#666;
  }
  </style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-new-employee/base-new-employee.vue